<template>
    <div>
        <app-sub-title text="Análisis de seguridad"/>
        <b-button v-if="!isClient" variant="primary" @click="startSave" class="btn-block-xs-only"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Cargar análisis de seguridad</b-button>
        <app-risk-analysis-filters
            @filter="onFilter"
            :venues="venues"
            :authors="authors"
        />
        <app-table-risk-analysis
            :data="data"
            @change-page="changePage"
            @remove-risk-analysis="startRemove"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->
        <app-pop-up title="Formulario análisis de seguridad" id="risk-analysis-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-risk-analysis-form :my-risk-analysis="selectRiskAnalysis" :onSave="onSave" :venues="venues" />
            </div>
            <div slot="buttons">
                 <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('risk-analysis-form.save')"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Cargar</button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="risk-analysis-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar este análisis de seguridad?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteRiskAnalysis(selectRiskAnalysis)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>
        <!-- fin de pop ups -->
    </div>
</template>

<script>
import riskAnalysisRepository from '../../../repositories/riskAnalysis.repository.js';
import venuesRepository from '../../../repositories/venues.repository.js';
import TableRiskAnalysis from './TableRiskAnalysis/TableRiskAnalysis.vue';
import RiskAnalysisFilters from './RiskAnalysisFilters/RiskAnalysisFilters.vue';
import RiskAnalysisForm from './RiskAnalysisForm/RiskAnalysisForm.vue';
export default {
    components: {
        appTableRiskAnalysis: TableRiskAnalysis,
        appRiskAnalysisFilters: RiskAnalysisFilters,
        appRiskAnalysisForm: RiskAnalysisForm
    },
    props: {
        theClient: {
            type: Object,
            default: null
        },
    },
    data(){
        return {
            data: {},
            filters: {},
            selectRiskAnalysis: '',
            venues: [],
            authors: [],
            page: 1,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            isClient: false
        }
    },
    methods: {
        loadRiskAnalysis(){
            const rar = {...riskAnalysisRepository};
            //listar por cliente
            const filters = {...this.filters, client: this.theClient.id, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir}
            rar.loadRiskAnalysis(filters, this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error => toastr.error('Error al listar los análisis de seguridad'));
        },
        loadVenues(){
            const vr = {...venuesRepository};
            vr.loadVenuesByClient(this.theClient.id)
                .then(data => this.venues = data)
                .catch(error => toastr.error('Error al cargar las sedes'));
        },
        loadAuthors(){
            const rar = {...riskAnalysisRepository};
            rar.loadAuthorsByClient(this.theClient.id)
                .then(data => this.authors = data)
                .catch(error => toastr.error('Error al cargar los autores'));
        },
        onFilter(filters){
            this.filters = filters;
            this.loadRiskAnalysis();
        },
        changePage(page){
            this.page = page;
            this.loadRiskAnalysis();
        },
        startSave(){
            this.selectRiskAnalysis = '';
            this.$bus.$emit('risk-analysis-form.open');
        },
        onSave() {
            this.$bus.$emit('risk-analysis-form.close');
            this.loadRiskAnalysis();
        },
        startRemove(riskAnalysis){
            this.selectRiskAnalysis = riskAnalysis;
            this.$bus.$emit('risk-analysis-remove.open');
        },
        deleteRiskAnalysis(riskAnalysis) {
            const rar = {...riskAnalysisRepository};
            rar.deleteRiskAnalysis(riskAnalysis.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadRiskAnalysis();
                        this.$bus.$emit('risk-analysis-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el análisis de seguridad');
                });
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadRiskAnalysis();
        },
        cleanForm() {
            this.$bus.$emit('risk-analysis-form.clean');
        },
        initialize(){
            this.isClient = this.user.profile.slug === 'cliente-admin' ? true: false;
            this.loadRiskAnalysis();
            this.loadVenues();
            this.loadAuthors();
        }
    },
    created(){
        this.initialize();
    }
}
</script>